(() => {
  angular.module('app').component('hostInpatientGuaranteeLettersDetailsOverviewComponent', {
    templateUrl: require('./overview.component.html'),
    controller: InpatientGLDetailsOverviewController,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '=',
    },
  });

  InpatientGLDetailsOverviewController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'abp.services.app.inpatientGuaranteeLetter',
    'abp.services.app.hostServiceRequest',
    'Hms.ServiceRequests.ServiceRequestStatus',
    'Hms.ServiceRequests.ServiceRequestType',
  ];

  function InpatientGLDetailsOverviewController(
    $scope,
    $state,
    $stateParams,
    inpatientGuaranteeLetterSvc,
    hostServiceRequestSvc,
    enumServiceRequestStatus,
    enumServiceRequestType
  ) {
    const vm = this;
    vm.loading = 0;
    vm.letterNumber = $stateParams.letterNumber;
    vm.pickUpRequest = pickUpRequest;
    vm.pickUpRequestWithParams = pickUpRequestWithParams;

    vm.enums = {
      serviceRequestStatus: enumServiceRequestStatus,
      serviceRequestType: enumServiceRequestType,
    };

    // TODO: Update permissions

    vm.permissions = {
      update: abp.auth.isGranted('GuaranteeLetters.Host.Update'),
      topUp: abp.auth.isGranted('GuaranteeLetters.Host.TopUp'),
      extend: abp.auth.isGranted('GuaranteeLetters.Host.Approve'),
    };

    init();

    function init() {
      getInpatientGuaranteeLetterDetail();
    }

    function getInpatientGuaranteeLetterDetail() {
      vm.loading += 1;
      inpatientGuaranteeLetterSvc
        .getInpatientGuaranteeLetterDetail({
          id: vm.letterNumber,
        })
        .success((data) => {
          vm.request = data.requestByPanel;
          vm.patient = data.patient;
          vm.organization = data.organization;
          vm.subsidiary = data.subsidiary;
          vm.guaranteeLetter = data.guaranteeLetter;
          vm.canPickUpRequest = data.canPickUpRequest;
          vm.isAssignee = data.isAssignee;
          vm.isEscalated = data.isEscalated;
          vm.currencyCode = data.currencyCode;
          vm.ianaTimeZoneId = data.ianaTimeZoneId;
          vm.serviceTypeName = data.serviceTypeName;
          vm.requestType = data.request.type;

          $scope.$emit('inpatientGlLoaded', vm);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function pickUpRequest(redirectUrl) {
      vm.loading += 1;
      hostServiceRequestSvc
        .updateServiceRequestProcessorId({ id: vm.request.id })
        .success(() => {})
        .finally(() => {
          vm.loading -= 1;
        });

      $state.go(redirectUrl, {
        letterNumber: vm.letterNumber,
        requestId: vm.request.id,
        memberId: vm.patient.id,
      });
    }

    function pickUpRequestWithParams(redirectUrl, params) {
      vm.loading += 1;
      hostServiceRequestSvc
        .updateServiceRequestProcessorId({ id: vm.request.id })
        .success(() => {})
        .finally(() => {
          vm.loading -= 1;
        });

        $state.go(redirectUrl, params);
    }
  }
})();
